<div class="card mt-2">
  <div class="card-body">
    <div class="float-right">
      <button type="button" routerLink="/intern/list-manage" class="btn btn-secondary mr-2">Applications</button>
      <button type="button" routerLink="/intern/actionType/list" class="btn btn-secondary mr-2">Action Item Types</button>
      <button type="button" routerLink="/intern/substatus/list" class="btn btn-secondary mr-2">Substatuses</button>
    </div>
    <h2 class="mb-3">Intern Action Item Templates</h2>
    <div class="mb-3">
      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Primary Status:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!primaryStatusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="primaryStatusList" [(ngModel)]="primaryStatusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

    </div>

    <i [hidden]="!loadingList && !loadingExcel && !savingItem" class="material-icons rotate text-muted">loop</i>
    <button (click)="editTemplate()" class="btn btn-secondary ml-2 mb-2">New Template</button>
    <p-table  #myTable [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="175px"></th>
          <th [pSortableColumn]="'ActionType'">Action Type<p-sortIcon [field]="'ActionType'"></p-sortIcon></th>
          <th [pSortableColumn]="'PrimaryStatus'">Primary Status<p-sortIcon [field]="'PrimaryStatus'"></p-sortIcon></th>
          <th [pSortableColumn]="'Substatus'">Substatus<p-sortIcon [field]="'Substatus'"></p-sortIcon></th>
          <th>Default Request</th>
          <th [pSortableColumn]="'IsEmployeeAction'">Employee Action<p-sortIcon [field]="'IsEmployeeAction'"></p-sortIcon></th>
          <th [pSortableColumn]="'Archived'">Archived<p-sortIcon [field]="'Archived'"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-list>
        <tr>
          <td>
            <button class="btn btn-secondary mr-2" (click)="editTemplate(list)" title="Edit Template" [disabled]="savingItem">
              <i class="fas fa-pencil"></i>
            </button>
            <button class="btn btn-secondary mr-2" (click)="deleteTemplate(list)" title="Delete Template" [disabled]="savingItem">
              <i class="fas fa-trash-alt"></i>
            </button>
          </td>
          <td>
            <span class="ui-column-title">Action Type</span>
            {{list.actionType}}
          </td>
          <td>
            <span class="ui-column-title">Primary Status</span>
            {{list.primaryStatus}}
          </td>
          <td>
            <span class="ui-column-title">Substatus</span>
            {{list.substatus}}
          </td>
          <td>
            <span class="ui-column-title">Default Request</span>
            {{list.defaultRequest}}
          </td>
          <td>
            <span class="ui-column-title">Employee Action</span>
            {{(list.isEmployeeAction == true ? "Yes" : "No")}}
          </td>
          <td>
            <span class="ui-column-title">Archived</span>
            {{(list.archived == true ? "Yes" : "No")}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</div>

<app-edit-intern-action-item-template></app-edit-intern-action-item-template>
